module.exports = __webpack_public_path__ + "img/utlinewhatsapp.a139bb8c.svg";